import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../api/api';
import { setRemoteMusicGenreCatalog } from './generated/localization';

// Build60 MusicGenreCatalogLifecycle: public presentation data, never account data.
// Share the existing taste/edition query so visiting those screens cannot duplicate a request.
export const musicGenreCatalogQuery = {
  queryKey: ['tasteGenreCatalog'],
  queryFn: async ({ signal }) => {
    const response = await api.getPublic('/genres', { signal, suppressGlobalError: true });
    const data = response?.data?.data ?? response?.data;
    if (
      !Array.isArray(data) ||
      !data.every(
        (item) => item && typeof item.nameKo === 'string' && typeof item.nameEn === 'string',
      )
    )
      throw Error('Invalid genre catalog');
    return data;
  },
  staleTime: 5 * 60 * 1000,
  refetchOnWindowFocus: true,
  retry: false,
};

export default function MusicGenreCatalogLifecycle() {
  const catalog = useQuery(musicGenreCatalogQuery);
  useEffect(() => {
    if (catalog.data) setRemoteMusicGenreCatalog(catalog.data);
  }, [catalog.data]);
  return null;
}
